import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { generateBiaxialLineChartData } from "./MarketInsightsData";
import { MarketInsightsChartTooltip } from "./MarketInsightsChartTooltip";

export function MarketInsightsBiaxialLineChart() {
    const data = generateBiaxialLineChartData(500);

    const formatXAxisTick = (value: string) => {
        const pointNum = parseInt(value.replace("Point ", ""));
        if (pointNum === 1) {
            return "Jun 16";
        } else if (pointNum === 126) {
            return "6a";
        } else if (pointNum === 251) {
            return "12p";
        } else if (pointNum === 376) {
            return "6p";
        } else if (pointNum === 500) {
            return "Jun 17";
        }
        return "";
    };

    const ticks = [
        "Point 1",
        "Point 126",
        "Point 251",
        "Point 376",
        "Point 500",
    ];

    return (
        <div className="rounded-[4px] dark:bg-[#2D3748] bg-white w-full h-full flex flex-auto flex-col">
            <ResponsiveContainer width="100%" height={350}>
                <LineChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid 
                        strokeDasharray="3 3" 
                        stroke="currentColor"
                        className="text-gray-400 dark:text-gray-700"
                    />
                    <XAxis
                        dataKey="name"
                        tickFormatter={formatXAxisTick}
                        ticks={ticks}
                        type="category"
                        tickLine={false}
                        axisLine={true}
                        stroke="currentColor"
                        className="text-gray-600 dark:text-gray-400"
                    />
                    <YAxis
                        yAxisId="right"
                        orientation="right"
                        domain={[0, 100]}
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(value) => `${value}%`}
                        stroke="currentColor"
                        className="text-gray-600 dark:text-gray-400"
                    />
                    <YAxis
                        yAxisId="left"
                        domain={[0, 25]}
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(value) => `${value} GW`}
                        stroke="currentColor"
                        className="text-gray-600 dark:text-gray-400"
                    />
                    <Tooltip content={<MarketInsightsChartTooltip unit={{
                        "Percentage of Load": "%",
                        "Renewable Generation": "GW"
                    }} />} />
                    <Legend 
                        verticalAlign="bottom"
                        height={36}
                        iconType="line"
                        wrapperStyle={{
                        paddingTop: '20px',
                        fontSize: '14px'
                        }}
                        formatter={(value) => (
                        <span className="text-neutral-600 dark:text-[#CEE0EF]">{value}</span>
                        )}
                    />
                    <Line
                        yAxisId="right"
                        type="monotone"
                        dataKey="pv"
                        name="Percentage of Load"
                        stroke="#8884d8"
                        dot={false}
                    />
                    <Line
                        yAxisId="left"
                        type="monotone"
                        dataKey="uv"
                        name="Renewable Generation"
                        stroke="#82ca9d"
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export default MarketInsightsBiaxialLineChart;
